import React from 'react';
import { InfoIcon } from '../InfoIcon';
import styles from './additionalinfo.module.css';
import { CONTACTS } from '../../data/contact';
export var AdditionalInfo = function (_a) {
    var note = _a.note;
    var contactInfo = CONTACTS.filter(function (c) { return c.key === note; })[0];
    var displayText = contactInfo.key === 'Thrift stores or the landfill'
        ? 'You may also drop it at nearby Thrift store'
        : "You must drop this item at " + contactInfo.display;
    return (React.createElement("div", { className: styles.additionalInfoContainer },
        React.createElement("p", null, displayText),
        React.createElement("div", { className: styles.additionalInfoIcons },
            React.createElement(InfoIcon, { name: 'Website', url: contactInfo.website }),
            React.createElement(InfoIcon, { name: 'Phone', url: "tel:" + contactInfo.phone }),
            contactInfo.directions && (React.createElement(InfoIcon, { name: 'Directions', url: contactInfo.directions })))));
};
